import * as React from "react";

import Container from "@mui/material/Container";

type PageContainerComponentProps = {
  children: React.ReactNode;
};

export const PageContainerComponent = ({ children }: PageContainerComponentProps) => {
  return (
    <Container maxWidth="lg" sx={{ pt: 3 }}>
      {children}
    </Container>
  );
};
